import {
    Entity,
  } from '../../../../../core';
  
  export const entityCapabilities = {
    searchText: 'Buscar entidad',
    addText: 'Agregar capacidad',
    export: false,
    filter: true,
    filterDefault: 'TD',
    checkbox: false,
    disabled: false,
    partialField: '',
    columns: [
      {
        title: 'Código',
        name: 'entityCode',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: Entity) => element.entityCode
      },
      {
        title: 'Tipo',
        name: 'entityType',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: Entity) => element.entityType
      },
      {
        title: 'Nombre',
        name: 'entityName',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: Entity) => element.entityName
      },
      {
        title: 'Dirección',
        name: 'entityAddress',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: Entity) => element.entityAddress
      },
      {
        title: 'Estado',
        name: 'active',
        type: 'boolean',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: Entity) => element.active
      },
      {
        title: 'Permite DaD',
        name: 'enabledDispatch',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: Entity) => element.enabledDispatch ? 'Sí' : 'No'
      },
      {
        title: 'Permite Picking',
        name: 'enabledPicking',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: Entity) => element.enabledPicking ? 'Sí' : 'No'
      },
      {
        title: 'Permite RT',
        name: 'enabledRetire',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: Entity) => element.enabledRetire ? 'Sí' : 'No'
      },
      {
        title: 'Nro. de reprogramaciones',
        name: 'dispatchMaxReprograms',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: Entity) => element.dispatchMaxReprograms
      },
      {
        title: 'Recojo de mercadería',
        name: 'enableMerchandiseCollect',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: Entity) => element.enableMerchandiseCollect ? 'Sí' : 'No'
      },
      {
        title: 'Cód. sistema de picking',
        name: 'pickingSystemCode',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: Entity) => element.pickingSystemCode
      }
    ],
    subTable: {}
  };
  